import { memo, useCallback, useEffect, useMemo, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { FreeMode } from 'swiper/modules'
import { Swiper, SwiperProps, SwiperSlide } from 'swiper/react'
import { getEventDetail, getSectionsDetail } from '../../api/home'
import { getCategoryCartSearch } from '../../api/product'
import { BtnHomeModuleMore } from '../Button'
import ProductCenterModal from '../product/ProductCenterModal'
import ProductModal from '../product/ProductModal'

import { CategoriesResponse } from '@shopby/shop-sdk'
import TagManager from 'react-gtm-module'
import 'swiper/css'
import 'swiper/css/free-mode'
import {
  EventContentType,
  EventDetailProduct,
  EventDetailType,
  HomeSectionType,
  SectionDetailType,
} from '../../@types/home'
import { AllCategoryFlatCategory } from '../../@types/product'
import { AFWebLinkType, RNPostMessage, sendSetAppsflyerEvent } from '../../js/postMessage'
import CommonCarousel from '../CommonCarousel'
import { useAppContext } from '../provider/AppProvider'
import { CategorySecondItem } from './CategorySecondItem'

type propsTypes = {
  el: any
  index: number
  homeModule?: HomeSectionType[]
  category: CategoriesResponse | null
  setTagName: React.Dispatch<React.SetStateAction<any>>
  setCheckTag: React.Dispatch<React.SetStateAction<number>>
  eventTagItem: EventContentType[]
}

const CategorySecond = ({ el, index, category, setTagName, setCheckTag, eventTagItem }: propsTypes) => {
  const [sectionItem, setSectionItem] = useState<SectionDetailType>()
  const [sectionProduct, setSectionProduct] = useState<EventDetailProduct[]>([])
  const [selectCategory, setSelectCategory] = useState<number>(0)
  const [item, setItem] = useState<EventDetailType | null>(null)
  const [isModal, setIsModal] = useState<boolean>(false)
  const [selectProductNo, setSelectProductNo] = useState<string>('')
  const [categoryItems, setCategoryItems] = useState<AllCategoryFlatCategory[]>([])
  const [categoryArray, setCategoryArray] = useState<number[]>([])
  const [selectItem, setSelectItem] = useState<any>([])
  const [allCategory, setAllCategory] = useState<any>([])
  const [eventTag, setEventTag] = useState<string>()
  const [eventNo, setEventNo] = useState<number>()
  const [categoryAllItem, setCategoryAllItem] = useState<any>([])
  const [includesArray, setIncludesArray] = useState<AllCategoryFlatCategory[]>([])
  const [exceptArray, setExceptArray] = useState<AllCategoryFlatCategory[]>([])
  const [isTouchMoving, setIsTouchMoving] = useState<boolean>(false)
  const { isAppView } = useAppContext()
  const navigate = useNavigate()

  const rankingClickHandler = useCallback(() => {
    const gtmNavigateClick = {
      dataLayer: {
        event: 'select_content',
        event_info: {
          content_type: '홈모듈',
          content_id: String(el.sectionNo),
          content_name: el.sectionName,
        },
      },
    }
    if (isAppView) {
      sendSetAppsflyerEvent({
        eventName: 'select_content',
        eventType: {
          content_type: '홈모듈',
          content_id: String(el.sectionNo),
          content_name: el.sectionName,
        },
      })
    }
    TagManager.dataLayer(gtmNavigateClick)
  }, [el.sectionNo, el.sectionName, isAppView])

  const touchMove = useCallback(() => {
    setIsTouchMoving(true)
  }, [])

  const touchEnd = useCallback(() => {
    setIsTouchMoving(false)
  }, [])

  const swiperProps: SwiperProps = useMemo(
    () => ({
      spaceBetween: 4,
      slidesPerView: 'auto',
      breakpoints: {
        768: {
          spaceBetween: 8,
        },
      },
      modules: [FreeMode],
      freeMode: false,
      centeredSlidesBounds: true,
      slideToClickedSlide: true,
      onTouchMove: touchMove,
      onTouchEnd: touchEnd,
    }),
    [touchMove, touchEnd]
  )

  useEffect(() => {
    const fetchSectionDetail = async () => {
      try {
        const res = await getSectionsDetail(el.sectionNo)
        setSectionItem(res.data[0])
      } catch (err) {
        console.error('Error fetching section detail:', err)
      }
    }

    fetchSectionDetail()
  }, [el.sectionNo])

  useEffect(() => {
    if (sectionItem) {
      const tag = sectionItem.sectionExplain.split('-')[1]
      setEventTag(tag)
      setTagName((prev: any) => [...prev, tag])
      setCheckTag((prev: any) => prev + 1)
    }
  }, [sectionItem, setTagName, setCheckTag])

  useEffect(() => {
    if (eventTagItem && eventTag) {
      const event = eventTagItem.find((item: any) => item.tag.includes(eventTag))
      setEventNo(event?.eventNo)
    }
  }, [eventTagItem, eventTag])

  useEffect(() => {
    const fetchEventDetail = async (eventNo: number) => {
      try {
        const res = await getEventDetail(eventNo, 'ADMIN_SETTING')
        setItem(res.data)
      } catch (err) {
        console.error('Error fetching event detail:', err)
      }
    }
    if (eventNo) fetchEventDetail(eventNo)
  }, [eventNo])

  useEffect(() => {
    if (category) {
      setAllCategory(category.flatCategories)
    }
  }, [category])

  useEffect(() => {
    if (allCategory.length && categoryArray.length) {
      const includesArray = allCategory.filter((category: AllCategoryFlatCategory) =>
        categoryArray.some((cat) => Object.values(category).includes(Number(cat)))
      )
      setIncludesArray(includesArray)
    }
  }, [allCategory, categoryArray])

  useEffect(() => {
    if (includesArray.length) {
      const exceptArray = includesArray.filter((el: AllCategoryFlatCategory) => el.depth1Label !== '브랜드')
      setExceptArray(exceptArray)
    }
  }, [includesArray])

  useEffect(() => {
    if (exceptArray.length) {
      const uniqueArray = Array.from(new Map(exceptArray.map((item: any) => [item.depth2CategoryNo, item])).values())
      setCategoryItems(uniqueArray)
    }
  }, [exceptArray])

  useEffect(() => {
    if (item) {
      const productsArray: EventDetailProduct[] = item.section.flatMap((el: any) => el.products)
      const categoryNosSet = productsArray
        .flatMap((product: EventDetailProduct) => product.displayCategoryNos.split('|'))
        .reduce((acc, categoryNo) => acc.add(categoryNo), new Set<string>())

      setSectionProduct(productsArray)
      setCategoryArray(Array.from(categoryNosSet).map(Number))
    }
  }, [item])

  useEffect(() => {
    if (categoryItems.length && selectCategory === 0) {
      setSelectCategory(categoryItems[0]?.depth2CategoryNo)
    }
  }, [categoryItems, selectCategory])

  useEffect(() => {
    if (categoryAllItem.length && sectionProduct.length) {
      const array = categoryAllItem
        .filter((item: any) =>
          sectionProduct.some((product: EventDetailProduct) => Number(item.productNo) === Number(product.productNo))
        )
        .slice(0, 4)
      setSelectItem(array)
    }
  }, [categoryAllItem, sectionProduct])

  useEffect(() => {
    const fetchCategoryCartSearch = async () => {
      if (selectCategory) {
        try {
          const response = await getCategoryCartSearch(selectCategory)
          setCategoryAllItem(response.data.items)
        } catch (error) {
          console.error('Error fetching category cart search:', error)
        }
      }
    }

    fetchCategoryCartSearch()
  }, [selectCategory])

  const scrollToButton = useCallback((e: EventTarget & HTMLButtonElement) => {
    const horizontalScroll = document.getElementById('horizontal_scroll')
    if (!horizontalScroll) return

    const buttonRect = e.getBoundingClientRect()
    const menuRect = horizontalScroll.getBoundingClientRect()
    const isOutOfView = buttonRect.left < menuRect.left || buttonRect.right > menuRect.right

    if (isOutOfView) {
      const scrollPosition = buttonRect.x - menuRect.x - horizontalScroll.clientWidth / 2 + e.clientWidth / 2
      horizontalScroll.scrollTo({ left: scrollPosition, behavior: 'smooth' })
    }
  }, [])

  return (
    <>
      <div className='best_ranking' onClick={rankingClickHandler} style={{ minHeight: isMobile ? '450px' : '766px' }}>
        <div className='home_module_title'>
          <p>{sectionItem?.promotionText}</p>
          <p>
            <strong>{sectionItem?.sectionExplain?.split('-', 1).join('')}</strong>
          </p>
        </div>
        <div className='tab_wrap'>
          <div className='tab_swiper_wrap'>
            <CommonCarousel
              swiperProps={swiperProps}
              items={categoryItems}
              CustomRenderItem={SwiperSlideItem}
              renderItem={(item: any) => (
                <div
                  className={selectCategory === item?.depth2CategoryNo ? 'on' : ''}
                  onTouchEnd={() => {
                    if (isMobile && !isTouchMoving) {
                      setSelectCategory(item.depth2CategoryNo)
                    }
                  }}
                  onClick={(): void => {
                    if (!isMobile) {
                      setSelectCategory(item.depth2CategoryNo)
                    }
                  }}
                  key={item.categoryNo}
                >
                  <button onClick={(e) => scrollToButton(e.currentTarget)}>{item.depth2Label}</button>
                </div>
              )}
            />
          </div>
        </div>
        <div className='best_ranking_list'>
          <ul>
            {selectItem.map((element: any, idx: number): JSX.Element => {
              return (
                <CategorySecondItem
                  selectCategory={selectCategory}
                  el={element}
                  idx={idx}
                  setIsModal={setIsModal}
                  setSelectProductNo={setSelectProductNo}
                  key={idx}
                  listId={el.sectionNo}
                  listName={el.sectionName}
                  categoryArray={category}
                ></CategorySecondItem>
              )
            })}
          </ul>
        </div>
        {selectItem && (
          <div className='btn_more_wrap'>
            <BtnHomeModuleMore
              onClick={(): void => {
                if (isAppView) {
                  RNPostMessage(AFWebLinkType.moveToLink, {
                    url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/exhibitiondetail/${item?.eventNo}`,
                  })
                } else {
                  navigate(`/exhibitiondetail/${item?.eventNo}`)
                }
              }}
            >
              더보기
            </BtnHomeModuleMore>
          </div>
        )}
        {index !== 0 && <hr />}
      </div>
      {isModal && isMobile && (
        <ProductModal
          setIsModal={setIsModal}
          headerText={'옵션선택'}
          selectProductNo={selectProductNo}
          listItem={selectItem}
          listId={el.sectionNo}
          listName={el.sectionName}
        ></ProductModal>
      )}
      {isModal && !isMobile && (
        <ProductCenterModal
          setIsModal={setIsModal}
          headerText={'옵션선택'}
          selectProductNo={selectProductNo}
          listItem={selectItem}
          listId={el.sectionNo}
          listName={el.sectionName}
        ></ProductCenterModal>
      )}
    </>
  )
}

export default memo(CategorySecond)

export const SwiperWrap = styled(Swiper)`
  padding: 0 18px;
  @media screen and (min-width: 768px) {
    padding: 0;
  }
`
export const SwiperSlideItem = styled(SwiperSlide)`
  width: auto !important;
  & .on {
    & button {
      color: var(--colWhite);
      background: var(--colBlack);
      border: 1px transparent solid;
    }
  }
  & button {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--colGray76);
    background: var(--colWhite);
    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    word-break: keep-all;
    height: 32px;
    border-radius: 32px;
    border: 1px var(--colGray3) solid;
    padding: 8px 14px;
    white-space: nowrap;
  }
  @media screen and (min-width: 768px) {
    & .on {
      & button {
        color: var(--colWhite);
        background: var(--colBlack);
        border: 1px transparent solid;
      }
    }
    & button {
      display: flex;
      justify-content: center;
      align-items: center;
      color: var(--colGray6);
      background: var(--colWhite);
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      word-break: keep-all;
      height: 40px;
      border-radius: 32px;
      border: 1px var(--colGray3) solid;
      padding: 10px 16px;
      white-space: nowrap;
    }
  }
`
